// client/src/sanity.js
import { createClient } from '@sanity/client';

// Debug environment variables
console.log('Sanity Environment Variables:', {
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION,
  hasWriteToken: !!process.env.REACT_APP_SANITY_WRITE_TOKEN
});

const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || '96l46hgm',  
  dataset: process.env.REACT_APP_SANITY_DATASET || 'production',
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION || '2023-09-11',
  useCdn: true,
});

export default client;

